// extracted by mini-css-extract-plugin
export default {"card":"Payouts_card__kOkAd"};